import React, { useEffect, useState } from 'react';
import Moment from 'react-moment';
import ProfileBox from '../../Components/ProfileBox/ProfileBox';
import { getClass, parseTime } from '../../Helper';
// import CancelButton from "../../Components/Buttons/CancelButton";
import ConfirmButton from '../../Components/Buttons/ConfirmButton';
import { API } from '../../API';
import { Link, withRouter } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import PersonAddIcon from '@mui/icons-material/PersonAdd'
require('./Dashboard.css');

const JobComponent = ({ smallHeader, job, history, recent, campuses }) => {
  const [campusAddress, setCampusAddress] = useState([]);

  useEffect(() => {
    let c = campuses.find((c) => c._id === job.campus_id);
    if (!c || !c._id && job?.campus) {
      c = job.campus
    }
    setCampusAddress(
      [c.address_line1, c.address_line2, c.suburb, c.state].filter(
        (ele) => !!ele
      )
    );
  }, []);

  const bookTeacher = () => {
    history.push('/CollegeCalendar', {
      teacher_name: {
        first_name: job.teacher.first_name,
        last_name: job.teacher.last_name,
        preferred_name: job.teacher.preferred_name,
      },
      teacher_avatar: job.teacher.img_url,
      teacher_id: job.teacher._id,
      level: job.level,
      campus_id: job.campus_id,
      show_modal: true,
    });
  };

  const classList = getClass();
  // let level = classList.find((cl) => cl.key === job.level);
  // level = level ? level.whole_name : job.level;
  let level = job.level

  const getValidStartDate = (job) => {
    return job.dates?.find(item => item.date >= job.booking_date)?.date
  }

  return (
    <ProfileBox header={recent ? 'Last Completed' : 'Upcoming Booking'} smallHeader={smallHeader}>
      <div className='column upcoming-classes-wrapper pb-3'>
        <div className='d-flex flex-row justify-content-center align-items-center mb-3 booking-title'>
          {job.teacher ? (
            <>
              <img
                src={job.teacher.img_url || '../../assets/img/avatar.png'}
                className='job-card-logo-container teacher-round-picture'
                alt="user's avatar"
              />
              <div>
                <h3 className='pl-1'>
                  {job.teacher.first_name} {job.teacher.last_name}
                </h3>
                <Link
                  to={`/NavigateToShareProfile?id=${job.teacher._id}`}
                  target="blank"
                >
                  <span
                    hidden={job.teacher.first_name === 'None' && job.teacher.last_name === 'Available'}
                    className="job-card-tag"
                  >
                    <Icon name="share" size="large" />
                      View Profile
                  </span>
                </Link>
              </div>
            </>
          ) : (
              <div className='d-flex'>
                <PersonAddIcon className='mr-1'/>
                <h3>Teacher allocation in progress</h3>
              </div>
          )}
        </div>

        <div className='booking-details'>
          <p className='text-left card-content-classes'>
            Booking for{' '}
            <strong>
              <Moment format='MMMM DD, YYYY'>{job.multiple_date ? getValidStartDate(job) : job.booking_date}</Moment>
            </strong>
            {job.end_booking_date &&
              job.booking_date !== job.end_booking_date && (
                <>
                  {' '}
                  to{' '}
                  <strong>
                    <Moment format='MMMM DD, YYYY'>
                      {job.end_booking_date}
                    </Moment>
                  </strong>
                </>
            )}
          </p>
          <p className='text-left card-content'>
            <Icon name='clock' />
            Arrive at <strong>{parseTime(job.arrival_time)}</strong> for{' '}
            <strong>{parseTime(job.start_time)}</strong> start, ends{' '}
            <strong>{parseTime(job.end_time)}</strong>
          </p>
          <p className='text-left card-content'>
            <Icon name='map marker alternate' />
            {campusAddress.join(', ')}
          </p>
          <p className='text-left card-content'>
            <span className='job-list-label'>Job</span>
            {level}
          </p>
          <p className='text-left card-content'>
            <span className='job-list-label'>Mode</span>
            {job.online ?
              job.deliver_from_home === undefined ? "Online"
                :
                (job.deliver_from_home ? "Online - Deliver from home" : "Online - Deliver on-campus")
              :
              "On Campus"}
          </p>
          <Link to={`CollegeJobList#${job._id}`} className='card-content center-link' style={{ color: "#4183c4" }}>
            <strong>
              {' '}
              View Job Details
              {' >>'}
            </strong>
          </Link>
          {!!job.teacher ?
            <button
              onClick={bookTeacher}
              className='btn btn-primary mt-2 center-button'
              hidden={!recent}>
                Re-book Teacher
            </button> : null
          }
        </div>
      </div>
    </ProfileBox>
  );
};

export default withRouter(JobComponent);
